import React from 'react';
import { Smartphone, Monitor, Video, PenTool, Briefcase } from 'lucide-react';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Social Media Management",
      icon: <Smartphone size={40} />,
      desc: "Social media is the modern-day storefront. We don’t just post content; we build communities. From platform-specific strategies and community engagement to data-driven analytics, we ensure your brand is heard."
    },
    {
      id: 2,
      title: "Graphic Design",
      icon: <PenTool size={40} />,
      desc: "Visual identity is the first handshake you have with a customer. Our design team blends psychology with aesthetics to create logos, branding kits, and marketing collateral that capture your essence."
    },
    {
      id: 3,
      title: "Video Editing",
      icon: <Video size={40} />,
      desc: "In a world of short attention spans, video is king. Whether it’s high-energy promotional content, cinematic brand stories, or engaging social snippets, our editors craft visual narratives that stop the scroll."
    },
    {
      id: 4,
      title: "Website Development",
      icon: <Monitor size={40} />,
      desc: "Your website should be your hardest-working employee. We build bespoke, responsive, and SEO-optimized websites that offer seamless user experiences, balancing beautiful UI with robust UX."
    },
    {
      id: 5,
      title: "Branding",
      icon: <Briefcase size={40} />,
      desc: "A brand is more than a logo; it's a promise. We build comprehensive brand strategies, defining your voice, tone, and visual identity to ensure consistency and impact across all channels."
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="section bg-light"
    >
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 className="text-red">Our Core Pillars</h1>
          <p>We don't believe in "one size fits all." Every project is a unique ecosystem.</p>
        </div>

        <motion.div 
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          {services.map((service) => (
            <motion.div 
              key={service.id} 
              className="service-card"
              variants={itemVariants}
              whileHover={{ scale: 1.03, boxShadow: "0 10px 20px rgba(0,0,0,0.2)" }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Services;